import { useState } from 'react'
import {gaEvent} from 'shared'
import {Modal} from 'shared/components/modal'

import teaserImage from './create_fundraising_event_modal.svg'

export const CreateFundraisingEventButton = ({project, ctaUrl, readmoreUrl}) => {
  const [show, setShow] = useState(false)

  const handleClick = () => {
    gaEvent('engagement', 'click fe_modal_open_link')
    setShow(true)
  }

  const onHide = () => {
    gaEvent('engagement', 'click fe_modal_close_link')
    setShow(false)
  }

  const content = <div>
    <img src={teaserImage} width='100%' className='m-b-sm' />

    {I18n.t('projects.show.stats.create_fundraising_event_modal_explanation')}

    <div className='text-center m-t'>
      <a className='btn btn-primary btn-large' href={ctaUrl} target='_blank' onClick={() => gaEvent('navigation', 'click fe_modal__create_button')}>
        {I18n.t('projects.show.stats.create_fundraising_event_modal_cta')}
      </a>
    </div>

    <div className='text-center m-t-sm'>
      <a href={readmoreUrl} target='_blank' onClick={() => gaEvent('navigation', 'click fe_modal__read_more_link')}>
        {I18n.t('projects.show.stats.create_fundraising_event_modal_readmore')}
      </a>
    </div>

  </div>

  return <div className='w-100'>
    <strong>{I18n.t('projects.show.stats.create_fundraising_event_teaser')}&nbsp;</strong>
    <a onClick={handleClick} style={{ color: '#357C00'}}>
      {I18n.t('projects.show.stats.create_fundraising_event_button')}
    </a>

    <Modal
      show={show}
      onHide={onHide}
      content={content}
      header={I18n.t('projects.show.stats.create_fundraising_event_modal_headline')}
    />
  </div>
}
